import React from "react";
import { Box, Typography, Link, CircularProgress, Paper, Stack } from "@mui/material";

function renderAssignmentAlertsBody({
  loadingUnassigned,
  unassignedBonds,
  getBondUrl,
  formatRelativeTime,
}) {
  if (loadingUnassigned) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!unassignedBonds?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No unassigned bonds.
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {unassignedBonds.map((bond, idx) => {
        const id = bond?.id ?? bond?.bond_id ?? idx;
        const href = getBondUrl?.(bond) ?? "#";
        const label = bond?.bond_number ?? bond?.case_name ?? `Bond ${id}`;
        return (
          <Box key={id} sx={{ display: "flex", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
            <Link href={href} underline="hover">
              {label}
            </Link>
            <Typography variant="caption" color="text.secondary">
              {formatRelativeTime?.(bond?.created_at ?? bond?.updated_at)}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
}

export default function AssignmentAlertsSection({
  unassignedBonds,
  loadingUnassigned,
  getBondUrl,
  formatRelativeTime,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
      <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600 }}>
        Assignment alerts
      </Typography>
      {renderAssignmentAlertsBody({
        loadingUnassigned,
        unassignedBonds,
        getBondUrl,
        formatRelativeTime,
      })}
    </Paper>
  );
}
